/* global Razorpay fbq */

import { useParams, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { ContestImage, RazorpayIcon, RazorpayText, Trusted, PercentageBadge  } from "./icons";
import axios from "axios";
import { ENV, path, RAZORPAY_KEY } from "../../path";
import ContestDates from "./ContestDates";
import JudgingParameters from "./JudgingParameters";
import RulesRegulation from "./RulesRegulation";
import Judges from "./Judges";
import Rewards from "./Rewards";
import { useSelector } from "react-redux";
import SignUpModal from "./SignUpModal";
import Header from "./Header";
import { useDisclosure } from "@chakra-ui/react";
import SubmissionUploadModal from "./SubmissionUploadModal";
import { toast } from "react-toastify";
import ReactGA from "react-ga4";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import DownloadAppConfettiButton from "./DownloadAppConfettiButton";
import ConfettiExplosion from "react-confetti-explosion";
import { v4 as uuid } from "uuid";
import { EventTypes, trackEvent } from "../../Utils/Analytics";
import LockIcon from '@mui/icons-material/Lock';
import { Modal } from "antd";
import CountDown from "./CountDown";
import ReferCard from "./ReferCard";
import PaymentSuccessModal from "./PaymentSuccessModal";
import AddPhoneModal from "./AddPhoneModal";
import { redirectToStore } from "../../Utils/genralUtility";

function ContestDetails() {
  const { id } = useParams();
  const { user, token } = useSelector((state) => state.AuthReducer);
  const {
    isOpen: isSubmissionModal,
    onOpen: openSubmissionModal,
    onClose: closeSubmissionModal,
  } = useDisclosure();
  const {
    isOpen: isPaymentSuccessModal,
    onOpen: openPaymentSuccessModal,
    onClose: closePaymentSuccessModal,
  } = useDisclosure();
  const {
    isOpen: isAddPhoneModal,
    onOpen: openAddPhoneModal,
    onClose: closeAddPhoneModal,
  } = useDisclosure();
  const history = useHistory();
  const [addPhonePurpose, setAddPhonePurpose] = useState(null);
  const [contestDetails, setContestDetails] = useState();
  const [signUpModalOpen, setSignUpModalOpen] = useState(false);
  const [IsuserRegistered, setuserRegistered] = useState(false);
  const [submission, setSubmission] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [RegistrationEnd, setRegistrationEnd] = useState();
  const [SubmissionStart, setSubmissionStart] = useState();
  const [SubmissionEnd, setSubmissionEnd] = useState();
  const [isUserJudge, setIsUserJudge] = useState(false);
  const [loading, setLoading] = useState(true);
  const [processingPayment, setProcessingPayment] = useState(false);
  const [isEnglish, setIsEnglish] = useState(true);
  const [submissionInfo, setSubmissionInfo] = useState();
  const [isExploding, setIsExploding] = useState(false);
  const [uploadConfig, setUploadConfig] = useState({
    chunkSize: 100 * 1024,
    uploadSpeed: "speed < 1 Mbps",
  });
  const [showRefundPolicy, setShowRefundPolicy] = useState(false)
  const [contestLoading, setContestLoading] = useState(false)
  const [activeDiscount, setActiveDiscount] = useState(null);
  const [referCode, setReferCode] = useState();

  const config = {
    host: `${path}`,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": `${path}`,
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    getContestDetails();
    submissionTypeCount(id);
  }, [id]);

  useEffect(() => {
    const hash = window.location.hash;

    // Example: "#/contest/67dbee4b1d099920ffb32a76?refId=xxx&openSignUp=true"
    const queryString = hash.split("?")[1];

    const params = new URLSearchParams(queryString);

    const refId = params.get("refId");
    const openSignUp = params.get("openSignUp");

    // Set uniqueId if not already set
    if (!localStorage.getItem("uniqueId")) {
      if (refId) {
        localStorage.setItem("uniqueId", refId);
      } else {
        localStorage.setItem("uniqueId", uuid());
      }
    }

    if (!user?._id && openSignUp === "true") {
      setSignUpModalOpen(true);
    }
  }, []);

  useEffect(() => {
    const orderId = localStorage.getItem("orderId");

    if (orderId) {
      setProcessingPayment(true);

      const intervalId = setInterval(async () => {
        try {
          const res = await axios.get(`${path}/payment/order/${orderId}`);

          if (res.data.paymentStatus !== "pending") {
            clearInterval(intervalId);
            getContestDetails();
            setProcessingPayment(false);
            localStorage.removeItem("orderId");
          }
        } catch (err) {
          console.error("Error fetching payment status:", err);
        }
      }, 5000);

      return () => clearInterval(intervalId);
    }
  }, []);

  useEffect(() => {
    const checkRegistrationAndSubmission = async () => {
      if (
        user?._id &&
        contestDetails &&
        contestDetails?.participatedUser.some((par) => par?._id === user?._id)
      ) {
        setuserRegistered(true);
        await checkSubmissionStatus();
      }
      setLoading(false);
    };
    const checkIfUserIsJudge = () => {
      const judgeArray =
        contestDetails?.responses?.sections[7]?.fields[0]?.response;
      if (user && judgeArray && judgeArray.length > 0) {
        const isJudge = judgeArray.some((judge) => judge?._id === user._id);
        setIsUserJudge(isJudge);
      }
    };
    checkRegistrationAndSubmission();
    checkIfUserIsJudge();
    getReferCode();
    getActiveDiscountForUser();

    // tracking contest-open event
    if (ENV === "prod" && contestDetails?._id) {
      trackEvent(EventTypes.CONTEST_OPEN, {
        contestId: contestDetails?._id,
        contestTitle:
          contestDetails?.responses.sections[2]?.fields[0]?.response,
        contestType: contestDetails?.responses.sections[0].description,
      });
    }
  }, [contestDetails, user]);

  useEffect(() => {
    const calculateVideoUploadChunkSize = async () => {
      const dummySize = 512 * 1024; // 512 KB
      const dummyData = new Uint8Array(dummySize);
      const blob = new Blob([dummyData]);

      const startTime = performance.now();
      await axios.post(`${path}/upload-speed-test`, blob, {
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });
      const endTime = performance.now();

      const durationSeconds = (endTime - startTime) / 1000;
      const speedBps = dummySize / durationSeconds;
      const speedMbps = (speedBps * 8) / (1024 * 1024);

      let chunkSize;
      let uploadSpeed;
      if (speedMbps < 1) {
        chunkSize = 100 * 1024; // 100 KB for very poor connections
        uploadSpeed = "speed < 1 Mbps";
      } else if (speedMbps < 5) {
        chunkSize = 2 * 1024 * 1024; // 2 MB for moderate 3G/slow 4G
        uploadSpeed = "1–5 Mbps";
      } else {
        chunkSize = 5 * 1024 * 1024; // 5 MB for fast 4G/5G/WiFi
        uploadSpeed = "speed > 5 Mbps";
      }
      console.log("chunk size: " + chunkSize + " " + uploadSpeed);
      setUploadConfig({ chunkSize, uploadSpeed });
    };

    calculateVideoUploadChunkSize();
  }, []);

  const getContestDetails = async () => {
    try {
      setContestLoading(true)
      const response = await axios.get(`${path}/contest/getContestsbyId/${id}`);
      if (response.status === 200) {
        console.info(response);
        setContestDetails(response?.data?.data);
        setCurrentDate(new Date());
        setRegistrationEnd(
          ConvertToDate(
            response?.data?.data?.responses?.sections[3].fields[0].response
          )
        );
        setSubmissionEnd(
          ConvertToDate(
            response?.data?.data?.responses?.sections[3].fields[3].response
          )
        );
        setSubmissionStart(
          ConvertToDate(
            response?.data?.data?.responses?.sections[3].fields[2].response
          )
        );
        if (ENV === "prod" && response?.data?.data) {
          const contestName =
            response.data.data.responses?.sections[2]?.fields[0]?.response ||
            "not found";
          const skillName =
            response.data.data.responses?.sections[0]?.description?.toLowerCase() ||
            "not found";
          const eventType =
            response.data.data.responses?.sections[2]?.fields[2]?.response?.toLowerCase() ||
            "not found";
          ReactGA.event("contest_opened", {
            contest_id: response.data.data._id,
            contest_name: contestName,
            user_id: user?._id || "not loggedIn",
            contest_type: eventType,
            skill: skillName,
          });
          fbq("trackCustom", "contest_opened", {
            contest_id: response.data.data._id,
            contest_name: contestName,
            user_id: user?._id || "not loggedIn",
            contest_type: eventType,
            skill: skillName,
            email: user?.email || "",
          });
        }
      }
    } catch (error) {
      console.info("Error in getting contest Details", error);
    } finally {
      setContestLoading(false)
    }
  };

  const submissionTypeCount = async (contestId) => {
    if (!contestId) {
      return;
    }
    try {
      const response = await axios.get(
        `${path}/v3/contest/submissionTypeCount/${contestId}`
      );
      setSubmissionInfo(response.data);
    } catch (error) {
      console.log("error while fetching submissions", error);
    }
  };

  const getReferCode = async () => {
    if(!user?._id) {
      return;
    }
    try {
      const res = await axios.get(`${path}/refer/code/${user._id}`);
      setReferCode(res.data.referralCode);
    } catch (error) {
      console.error("Error getReferCode: "+JSON.stringify(error));
      if(error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Error fetching referral code, please try again later!");
      }
    }
  }

  const getActiveDiscountForUser = async () => {
    const oldFee = contestDetails?.responses?.sections[2]?.fields[1]?.response;
    const paymentType = contestDetails?.responses?.sections[2]?.fields[6]?.response;
    const slotFeePercentage = parseInt(contestDetails?.responses?.sections[8]?.fields[5]?.response ?? 0);
    if(!user?._id || !contestDetails?._id || oldFee === null || oldFee === undefined || !paymentType) {
      return;
    }
    try {
      let res;
      if(paymentType === "Slotpaid") {
        res = await axios.get(`${path}/discount/user/${user._id}/contest/${contestDetails._id}`);
      } else {
        res = await axios.get(`${path}/discount/user/${user._id}/active`, { params: { contestId: contestDetails._id } });
      }
      if(res.data.discount) {
        const oldFeeFloat = parseFloat(oldFee)
        const discountPercentage = parseFloat(res.data.discount?.percentage);

        let newFee, newSlotRegisterFee, newSlotFinalFee;
        if(paymentType === "Slotpaid") {
          const discountedAmount = oldFee - ((oldFee * discountPercentage)/100);
          newSlotRegisterFee = Math.round(discountedAmount * (slotFeePercentage / 100));
          newSlotFinalFee = discountedAmount - newSlotRegisterFee;
        } else {
          newFee = Math.round(oldFeeFloat - ((oldFeeFloat * discountPercentage) / 100))
        }
        const text = res.data.discount.type === "FIRST_PURCHASE"
          ? `You get ${discountPercentage}% OFF (First Purchase)`
          : res.data.discount.type === "ADMIN_COUPON"
            ? `You get ${discountPercentage}% OFF (Coupon ${res.data.discount.code})`
            : `You get ${discountPercentage}% OFF (Referral Reward)`

        setActiveDiscount({
          ...res.data.discount,
          newFee,
          newSlotRegisterFee,
          newSlotFinalFee,
          text
        });
      } else {
        setActiveDiscount(null);
      }
    } catch (error) {
      console.error("Error in getActiveDiscountForUser: "+JSON.stringify(error));
      toast.error("Error getting discount, please try refreshing!")
    }
  }

  const ConvertToDate = (stringDate) => {
    let dateString = stringDate;
    // Extract date and time components
    let [datePart, timePart] = dateString.split(" at ");

    // Extract year, month, and day
    let [year, month, day] = datePart.split("-");

    // Extract hour and minute
    let [hour, minute] = timePart.split(":");

    // Create a new Date object
    let dateObject = new Date(year, month - 1, day, hour, minute);

    return dateObject;
  };

  const checkSubmissionStatus = async () => {
    const response = await axios.get(
      `${path}/contest/hasUserContributed/${id}/${user._id}`,
      config
    );
    if (response?.data?.length === 0 || response?.data === null) {
      setSubmission(null);
    }

    if (response.data) {
      setSubmission(response.data);
    }
  };

  const paymentHandler = async () => {
    setLoading(true);
    try {
      const contestTitle =
        contestDetails.responses.sections[2].fields[0].response;
      const contestSkill = contestDetails.responses.sections[0].description;
      console.log(SubmissionEnd < new Date(), SubmissionEnd, new Date());
  
      if (SubmissionEnd < new Date()) {
        toast.error("Submission time has ended, cannot proceed with payment!");
        return;
      }
  
      const orderOptions = {
        receipt: user.username + Date.now(),
        notes: {
          submissionId: submission._id,
          username: user.username,
          paymentType: "Postpaid",
        },
      };
  
      const res = await axios.post(`${path}/v2/payment/createOrder`, {
        orderOptions,
        contestId: contestDetails?._id,
        userId: user._id
      }, config);
  
      if (res?.data?.id) {
        localStorage.setItem("orderId", res.data.id);
      }
  
      const successHandler = (data) => {
        // crashlytics().log("Success for RazorpayCheckout: ", data);
        const registration = {
          user: user,
          contestId: contestDetails._id,
        };
        const options = { ...data, submissionId: submission._id, discountId: res.data?.notes?.discountId };
  
        // crashlytics().log("Sending request to /payment/validatePayment");
        axios
          .post(`${path}/payment/validatePayment`, { options, registration })
          .then(async (response) => {
            if (response.status === 201) {
              // crashlytics().log("Registered in event successfully.");
  
              setSubmission((prev) => ({
                ...prev,
                paid: response.data && response.data.paid,
              }));
  
              toast.success("Payment successfully!");
              await submissionTypeCount(contestDetails._id)
              if (ENV === "prod") {
                ReactGA.event("purchase", {
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                  transaction_id: data.razorpay_payment_id,
                  items: [
                    {
                      item_name: contestTitle,
                      price: parseInt(res.data.amount/100),
                      item_category: contestSkill,
                    },
                  ],
                });
                fbq("track", "Purchase", {
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                  content_category: contestSkill,
                  content_name: contestTitle,
                  contents: [{ id: contestDetails._id, quantity: 1 }],
                  content_ids: [contestDetails._id],
                });
              }
              openPaymentSuccessModal()
            } else {
              // crashlytics().log("Database failed to register user");
              toast.error(
                "Payment failed, please try refreshing app before trying again."
              );
            }
          })
          .catch(() =>
            toast.error(
              "Payment failed, please try refreshing app before trying again."
            )
          )
          .finally(() => {
            localStorage.removeItem("orderId");
            closeSubmissionModal();
          });
      };
  
      var options = {
        description: `Registration Fee for ${contestTitle}`,
        image:
          "https://blaccsckullplatformsprivatelim.box.com/shared/static/9cpip1jvokk59u8hvmzk4biq9j3m4i31.png",
        currency: "INR",
        // key: "rzp_test_0afNUeK57l5gZi",
        key: RAZORPAY_KEY,
        amount: res.data.amount,
        name: "FeedAnts",
        order_id: res.data.id,
        handler: successHandler,
        prefill: {
          email: user.email,
          name: user.firstName + user.lastName,
          contact: "0000000000",
        },
        theme: { color: "#53a20e" },
        modal: {
          ondismiss: function () {
            console.info("Checkout form closed");
            localStorage.removeItem("orderId");
          },
        },
      };
      // crashlytics().log("Order options: ", orderOptions);
      // crashlytics().log("Sending request to /payment/createOrder");
  
      // Razorpay is globally avaliable
      const rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", async function (error) {
        // crashlytics().log(`Payment Failed during register: ${error}`);
        // crashlytics().recordError(new Error(error));
        toast.error(
          "Payment failed, please contact feedants support if amount was deducted."
        );
        await axios.post(`${path}/payment/paymentFailAlert`, {
          userId: user._id,
          orderId: res.data.id,
          error: error,
        });
      });
      rzp1.open();
    } finally {
      setLoading(false);
    }
  };

  const slotFinalPaymentHandler = async () => {
    setLoading(true);
    try {
      const contestTitle =
        contestDetails.responses.sections[2].fields[0].response;
      const contestSkill = contestDetails.responses.sections[0].description;
      console.log(SubmissionEnd < new Date(), SubmissionEnd, new Date());
  
      if (SubmissionEnd < new Date()) {
        toast.error("Submission time has ended, cannot proceed with payment!");
        return;
      }
  
      const orderOptions = {
        receipt: user.username + Date.now(),
        notes: {
          submissionId: submission._id,
          user: { _id: user._id, expoPushTokens: user.expoPushTokens },
          contestId: contestDetails._id,
          username: user.username,
          paymentType: "SlotFinalPayment"
        },
      };
  
      const res = await axios.post(`${path}/payment/createSlotOrder`, {
        orderOptions,
        contestId: contestDetails?._id,
        userId: user._id
      }, config);
  
      if (res?.data?.id) {
        localStorage.setItem("orderId", res.data.id);
      }
  
      const successHandler = (data) => {
        // crashlytics().log("Success for RazorpayCheckout: ", data);
        // crashlytics().log("Sending request to /payment/validatePayment");
        axios
          .post(`${path}/payment/validateSlotFinalPayment`, data)
          .then(async (response) => {
            if (response.status === 201) {
              // crashlytics().log("Registered in event successfully.");
  
              setSubmission((prev) => ({
                ...prev,
                paid: response.data && response.data.paid,
              }));
  
              toast.success("Payment successfully!");
              if (ENV === "prod") {
                ReactGA.event("purchase", {
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                  transaction_id: data.razorpay_payment_id,
                  items: [
                    {
                      item_name: contestTitle,
                      price: parseInt(res.data.amount/100),
                      item_category: contestSkill,
                    },
                  ],
                });
                fbq("track", "Purchase", {
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                  content_category: contestSkill,
                  content_name: contestTitle,
                  contents: [{ id: contestDetails._id, quantity: 1 }],
                  content_ids: [contestDetails._id],
                });
              }
              openPaymentSuccessModal()
            } else {
              // crashlytics().log("Database failed to register user");
              toast.error(
                "Payment failed, please try refreshing app before trying again."
              );
            }
          })
          .catch(() =>
            toast.error(
              "Payment failed, please try refreshing app before trying again."
            )
          )
          .finally(() => {
            localStorage.removeItem("orderId");
            closeSubmissionModal();
          });
      };
  
      var options = {
        description: `Final Submission Fee for ${contestTitle}`,
        image:
          "https://blaccsckullplatformsprivatelim.box.com/shared/static/9cpip1jvokk59u8hvmzk4biq9j3m4i31.png",
        currency: "INR",
        // key: "rzp_test_0afNUeK57l5gZi",
        key: RAZORPAY_KEY,
        amount: res.data.amount,
        name: "FeedAnts",
        order_id: res.data.id,
        handler: successHandler,
        prefill: {
          email: user.email,
          name: user.firstName + user.lastName,
          contact: "0000000000",
        },
        theme: { color: "#53a20e" },
        modal: {
          ondismiss: function () {
            console.info("Checkout form closed");
            localStorage.removeItem("orderId");
          },
        },
      };
      // crashlytics().log("Order options: ", orderOptions);
      // crashlytics().log("Sending request to /payment/createOrder");
  
      // Razorpay is globally avaliable
      const rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", async function (error) {
        // crashlytics().log(`Payment Failed during register: ${error}`);
        // crashlytics().recordError(new Error(error));
        toast.error(
          "Payment failed, please contact feedants support if amount was deducted."
        );
        await axios.post(`${path}/payment/paymentFailAlert`, {
          userId: user._id,
          orderId: res.data.id,
          error: error,
        });
      });
      rzp1.open();
    } finally {
      setLoading(false);
    }
  };

  const DiscountCard = ({ activeDiscount }) => {
    return <div className="relative flex flex-row items-center justify-center gap-x-1 rounded-t-lg p-2 -bottom-1 -z-10 bg-[linear-gradient(to_right,_#e6feef_0%,_#cefde0_5%,_#AFFCCD_50%,_#cefde0_95%,_#e6feef_100%)]">
      <img src={PercentageBadge} alt="Percentage Icon" className="size-4" />
      <p className="text-[#024D4D] text-[14px] font-gilroy-semibold">{activeDiscount.text}</p>
    </div>
  }

  const secureUploadHandler = () => {
    if(!user.phone) {
      setAddPhonePurpose("SUBMISSION");
      openAddPhoneModal()
    } else {
      openSubmissionModal()
    }
  }

  const DiscountText = ({ oldFee, newFee, isRegister }) => {
    return <div className="flex flex-row items-center gap-1">
      <span>Pay</span>
      <div>
        <span className="text-[#008080] text-[12px] line-through rounded-l-lg rounded-r-lg bg-white px-1">₹{oldFee}</span>
      </div>
      <span>{`₹${newFee} to ${isRegister? "Register":"Submit"}`}</span>
    </div>
  }

  const renderActionButton = () => {
    const paymentType = contestDetails?.responses?.sections[2]?.fields[6]?.response;
    if (loading) {
      return (
        <button className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium">
          <div className="border-2 border-t-white border-teal-400 size-5 rounded-full animate-spin" />
        </button>
      );
    }
    if (isUserJudge) {
      return (
        <button
          onClick={() => redirectToStore("judge_check_submission")}
          className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium">
          Install App To Check Submissions
        </button>
      );
    }
    if (SubmissionEnd < currentDate) {
      return (
        <button
          disabled={true}
          className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium opacity-50">
          Contest Ended
        </button>
      );
    }
    if (IsuserRegistered) {
      if (submission && submission.mediaUrl) {
        if(submission.paid) {
          return <DownloadAppConfettiButton setIsExploding={setIsExploding}/>
        } else {
          let finalFee, registerFee;
          const fee = parseInt(contestDetails?.responses?.sections[2]?.fields[1]?.response || 0);
          if(paymentType === "Slotpaid") {
            const slotFeePercentage = parseInt(contestDetails?.responses?.sections[8]?.fields[5]?.response || 0);
            registerFee = Math.round(fee * (slotFeePercentage/100));
            finalFee = fee - registerFee;
          }
          return <div className="flex flex-col">
            {!processingPayment && paymentType !== "Slotpaid" && activeDiscount && <DiscountCard activeDiscount={activeDiscount} />}
            {!processingPayment && paymentType === "Slotpaid" &&
                <div className="relative flex flex-row items-center justify-center rounded-t-lg p-2 -bottom-1 -z-10 bg-white">
                  <p className="text-[#024D4D] text-[14px] font-gilroy-semibold">{`Paid ${activeDiscount? activeDiscount.newSlotRegisterFee :registerFee} INR, pay the remaining amount. ${activeDiscount? `(${activeDiscount.percentage}% applied)`: ""}`}</p>
                </div>}
            <button
              onClick={async () => {
                if (SubmissionEnd > new Date()) {
                  if(paymentType === "Slotpaid") {
                    await slotFinalPaymentHandler()
                  } else {
                    await paymentHandler();
                  }
                } else {
                  toast.error("Submission time ended.");
                }
              }}
              disabled={processingPayment}
              className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium">
              {function(){
                if(processingPayment) {
                  return "Processing Payment"
                } 
                if(paymentType === "Slotpaid") {
                  if(activeDiscount) {
                    return <DiscountText oldFee={finalFee} newFee={activeDiscount.newSlotFinalFee} isRegister={false} />
                  } else {
                    return `Pay ₹${finalFee} to Submit`
                  }
                } else {
                  if(activeDiscount) {
                    return <DiscountText oldFee={fee} newFee={activeDiscount.newFee} isRegister={false} />
                  } else {
                    return `Pay ₹${fee} to Submit`
                  }
                } 
              }()}
            </button>
          </div>
        }
      } else if (SubmissionStart < currentDate) {
        const isUploadSubmissionType =
          contestDetails?.responses?.sections[2]?.fields[7]?.response ===
          "Upload";
        if (isUploadSubmissionType) {
          return (<div className="flex flex-col">
            {activeDiscount && <DiscountCard activeDiscount={activeDiscount} />}
            <button
              className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium gap-2"
              onClick={secureUploadHandler}>
              <LockIcon className="size-5 " /> Secure Upload
            </button>
          </div>
          );
        } else {
          return (
            <>
              <p className="text-sm text-red-600 font-gilroy-regular">
                *This is a live contest where participants must submit a
                live-recorded video to participate.
              </p>
              <button
                onClick={() => redirectToStore("record_contest")}
                className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium">
                Install App to Record Submission
              </button>
            </>
          );
        }
      } else {
        return (
          <button className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium">
            Submission Not Started Yet
          </button>
        );
      }
    }

    const participationLimit = contestDetails?.responses?.sections[8]?.fields[6]?.response
    const isParticipationLimitReached = 
      paymentType === "Slotpaid" &&
      contestDetails.participatedUser?.length >= participationLimit

    if ((currentDate > RegistrationEnd) || isParticipationLimitReached) {
      return (
        <button
          disabled
          className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium opacity-50">
          Registration Closed
        </button>
      );
    }

    return (
      <>
        {paymentType === "Prepaid" && (
          <p className="text-yellow-800 bg-yellow-100 border border-yellow-300 p-2 rounded-md text-sm mb-1">
            Please note that this is a prepaid contest, and registration will be
            confirmed only after the payment has been successfully completed.
          </p>
        )}
        <div className="flex flex-col">
          {!processingPayment && activeDiscount && (
          <div className="relative flex flex-row items-center justify-center gap-x-1 rounded-t-lg pt-2 pb-3 -bottom-1 -z-10 bg-[linear-gradient(to_right,_#e6feef_0%,_#cefde0_5%,_#AFFCCD_50%,_#cefde0_95%,_#e6feef_100%)]">
            <img src={PercentageBadge} alt="Percentage Icon" className="size-4" />
            <p className="text-[#024D4D] text-[14px] font-gilroy-semibold">You get {activeDiscount.percentage}% discount.</p>
          </div>)}
          <button
            onClick={() => handleRegisterClick()}
            disabled={processingPayment}
            className="px-6 py-3 flex items-center justify-center rounded-lg bg-[#008080] text-white text-lg font-gilroy-medium">
              {function() {
                const oldFee = parseInt(contestDetails?.responses?.sections[2]?.fields[1]?.response || 0);
                if(processingPayment) {
                  return "Processing payment"
                }
                if(paymentType === "Prepaid") {
                  if(activeDiscount) {
                    return <DiscountText oldFee={oldFee} newFee={activeDiscount.newFee} isRegister={true} />
                  } else {
                    return `Pay ₹${oldFee} to Register`
                  }
                } else if(paymentType === "Slotpaid") {
                  const slotFeePercentage = parseInt(contestDetails?.responses?.sections[8]?.fields[5]?.response || 0);
                  const slotFee = Math.round(parseInt(oldFee) * (parseInt(slotFeePercentage)/100));
                  if(activeDiscount) {
                    return <div className="flex flex-row items-center gap-1">
                      <span>Pay {slotFeePercentage}% to Register -</span>
                      <div>
                        <span className="text-[#008080] text-[12px] line-through rounded-l-lg rounded-r-lg bg-white px-1">₹{slotFee}</span>
                      </div>
                      <span>₹{activeDiscount.newSlotRegisterFee}</span>
                    </div>
                  } else {
                    return `Pay ${slotFeePercentage}% to Register - ₹${slotFee}`
                  }
                } else {
                  return "Register for Free"
                }
              }()}
          </button>
        </div>
      </>
    );
  };

  const handleRegisterClick = () => {
    try {
      const ua = navigator.userAgent.toLowerCase();
      console.info("ua", ua);
      const isInstagram = ua.includes("instagram");
      const isAndroid = ua.includes("android");

      if (isInstagram && isAndroid) {
        return redirectToDefaultBrowser();
      }

      if (!contestDetails) {
        return;
      }
      // tracking register-click event
      if (ENV === "prod") {
        trackEvent(EventTypes.REGISTER_CLICK, {
          contestId: contestDetails._id,
          contestTitle:
            contestDetails?.responses.sections[2]?.fields[0]?.response,
          contestType: contestDetails?.responses.sections[0].description,
        });
      }
      if (user?._id) {
        const paymentType =
          contestDetails?.responses?.sections[2]?.fields[6]?.response;
        if (paymentType === "Prepaid") {
          registerWithPayment(user);
        } else if(paymentType === "Postpaid") {
          register(user);
        } else if(paymentType === "Slotpaid") {
          registerSlotWithPayment(user);
        }
      } else {
        setSignUpModalOpen(true);
      }
    } catch (error) {
      console.error("Error on register click", error);
    }
  };

  const redirectToDefaultBrowser = () => {
    const refId = localStorage.getItem("uniqueId");

    // Get full hash path (e.g. "#/contest/abc123")
    const hash = window.location.hash; // includes the route part after #
    const route = hash.split("?")[0] || "#/"; // just the path without query

    // Attach query parameters
    const query = `refId=${refId}&openSignUp=true`;

    // Build final redirect URL
    const redirectUrl = `${window.location.origin}/${route}?${query}`;

    const intentUrl =
      "intent://" +
      redirectUrl.replace(/^https?:\/\//, "") +
      "#Intent;scheme=https;package=com.android.chrome;end";

    window.location.href = intentUrl;
  };

  const registerWithPayment = async (user) => {
    setLoading(true);
    try {
      //check if user has already participated for after login
      if (
        !user._id ||
        !contestDetails ||
        contestDetails?.participatedUser?.some((par) => par?._id === user?._id)
      ) {
        return;
      }
      const fee = contestDetails.responses.sections[2].fields[1].response;
      const contestTitle =
        contestDetails.responses.sections[2].fields[0].response;
      const contestSkill = contestDetails.responses.sections[0].description;
      console.log(SubmissionEnd < new Date(), SubmissionEnd, new Date());
      if (!fee || !contestDetails || !user) {
        return;
      }
      if (SubmissionEnd < new Date()) {
        toast.error("Submission time has ended, cannot proceed with payment!");
        return;
      }

      const orderOptions = {
        receipt: user.username + Date.now(),
        notes: {
          username: user.username,
          user: { _id: user._id, expoPushTokens: user.expoPushTokens },
          contestId: contestDetails._id,
          paymentType: "Prepaid",
        },
      };

      const res = await axios.post(`${path}/v2/payment/createOrder`, {
        orderOptions,
        contestId: contestDetails._id,
        userId: user._id
      }, config);

      if (res?.data?.id) {
        localStorage.setItem("orderId", res.data.id);
      }

      const successHandler = (data) => {
        // crashlytics().log("Success for RazorpayCheckout: ", data);
        const registration = {
          user: user,
          contestId: contestDetails._id,
        };

        // crashlytics().log("Sending request to /payment/validatePayment");
        axios
          .post(`${path}/payment/preValidatePayment`, {
            options: data,
            registration,
            discountId: res.data?.notes?.discountId
          })
          .then(async (response) => {
            if (response.status === 201) {
              // crashlytics().log("Registered in event successfully.");
              setuserRegistered(true);
              setContestDetails(prev => ({ ...prev, participatedUser: [...prev.participatedUser, user] }))

              toast.success("Registered successfully!");
              if (ENV === "prod") {
                ReactGA.event("purchase", {
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                  transaction_id: data.razorpay_payment_id,
                  items: [
                    {
                      item_name: contestTitle,
                      price: parseInt(res.data.amount/100),
                      item_category: contestSkill,
                    },
                  ],
                });
                ReactGA.event("contest_registed", {
                  user_id: user._id,
                  contest_id: id,
                  contest_name: contestTitle,
                });
                fbq("track", "Purchase", {
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                  content_category: contestSkill,
                  content_name: contestTitle,
                  contents: [{ id: contestDetails._id, quantity: 1 }],
                  content_ids: [contestDetails._id],
                });
                fbq("trackCustom", "contest_registed", {
                  user_id: user._id,
                  contest_id: id,
                  contest_name: contestTitle,
                  email: user?.email || "",
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                });
              }
            } else {
              // crashlytics().log("Database failed to register user");
              toast.error("Payment failed");
            }
          })
          .catch(() =>
            toast.error(
              "Payment failed, please try refreshing app before trying again."
            )
          )
          .finally(() => localStorage.removeItem("orderId"));
      };

      var options = {
        description: `Registration Fee for ${contestTitle}`,
        image:
          "https://blaccsckullplatformsprivatelim.box.com/shared/static/9cpip1jvokk59u8hvmzk4biq9j3m4i31.png",
        currency: "INR",
        // key: "rzp_test_0afNUeK57l5gZi",
        key: RAZORPAY_KEY,
        amount: res.data.amount,
        name: "FeedAnts",
        order_id: res.data.id,
        handler: successHandler,
        prefill: {
          email: user.email,
          name: user.firstName + user.lastName,
          contact: "0000000000",
        },
        theme: { color: "#53a20e" },
        modal: {
          ondismiss: function () {
            console.info("Checkout form closed");
            localStorage.removeItem("orderId");
          },
        },
      };

      // crashlytics().log("Order options: ", orderOptions);
      // crashlytics().log("Sending request to /payment/createOrder");

      // Razorpay is globally avaliable
      const rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", async function (error) {
        // crashlytics().log(`Payment Failed during register: ${error}`);
        // crashlytics().recordError(new Error(error));
        toast.error(
          "Payment failed, please contact feedants support if amount was deducted."
        );
        await axios.post(`${path}/payment/paymentFailAlert`, {
          userId: user._id,
          orderId: res.data.id,
          error: error,
        });
      });
      rzp1.open();
    } catch (error) {
      console.error("Error registerWithPayment: " + error);
      toast.error("Payment failed, please try again!");
    } finally {
      setLoading(false);
    }
  };

  const registerSlotWithPayment = async (user) => {
    setLoading(true);
    try {
      //check if user has already participated for after login
      if (
        !user._id ||
        !contestDetails ||
        contestDetails?.participatedUser?.some((par) => par?._id === user?._id)
      ) {
        return;
      }
      const fee = contestDetails.responses.sections[2].fields[1].response;
      const contestTitle =
        contestDetails.responses.sections[2].fields[0].response;
      const contestSkill = contestDetails.responses.sections[0].description;
      console.log(SubmissionEnd < new Date(), SubmissionEnd, new Date());
      if (!fee || !contestDetails || !user) {
        return;
      }
      if (SubmissionEnd < new Date()) {
        toast.error("Submission time has ended, cannot proceed with payment!");
        return;
      }

      const orderOptions = {
        receipt: user.username + Date.now(),
        notes: {
          username: user.username,
          user: { _id: user._id, expoPushTokens: user.expoPushTokens },
          contestId: contestDetails._id,
          paymentType: "SlotInitialPayment",
        },
      };

      const res = await axios.post(`${path}/payment/createSlotOrder`, {
        orderOptions,
        contestId: contestDetails._id,
        userId: user._id
      }, config);

      if (res?.data?.id) {
        localStorage.setItem("orderId", res.data.id);
      }

      const successHandler = (data) => {
        // crashlytics().log("Success for RazorpayCheckout: ", data);
        // crashlytics().log("Sending request to /payment/validatePayment");
        axios
          .post(`${path}/payment/validateSlotInitialPayment`, data)
          .then(async (response) => {
            if (response.status === 201) {
              // crashlytics().log("Registered in event successfully.");
              setuserRegistered(true);
              setContestDetails(prev => ({ ...prev, participatedUser: [...prev.participatedUser, user] }))

              toast.success("Registered successfully!");

              if (!user.phone) {
                setAddPhonePurpose("POST_SLOT_PAYMENT");
                openAddPhoneModal();
              }
              if (ENV === "prod") {
                ReactGA.event("purchase", {
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                  transaction_id: data.razorpay_payment_id,
                  items: [
                    {
                      item_name: contestTitle,
                      price: parseInt(res.data.amount/100),
                      item_category: contestSkill,
                    },
                  ],
                });
                ReactGA.event("contest_registed", {
                  user_id: user._id,
                  contest_id: id,
                  contest_name: contestTitle,
                });
                fbq("track", "Purchase", {
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                  content_category: contestSkill,
                  content_name: contestTitle,
                  contents: [{ id: contestDetails._id, quantity: 1 }],
                  content_ids: [contestDetails._id],
                });
                fbq("trackCustom", "contest_registed", {
                  user_id: user._id,
                  contest_id: id,
                  contest_name: contestTitle,
                  email: user?.email || "",
                  currency: "INR",
                  value: parseInt(res.data.amount/100),
                });
              }
            } else {
              // crashlytics().log("Database failed to register user");
              toast.error("Payment failed");
            }
          })
          .catch(() =>
            toast.error(
              "Payment failed, please try refreshing app before trying again."
            )
          )
          .finally(() => localStorage.removeItem("orderId"));
      };

      var options = {
        description: `Slot Registration Fee for ${contestTitle}`,
        image:
          "https://blaccsckullplatformsprivatelim.box.com/shared/static/9cpip1jvokk59u8hvmzk4biq9j3m4i31.png",
        currency: "INR",
        // key: "rzp_test_0afNUeK57l5gZi",
        key: RAZORPAY_KEY,
        amount: res.data.amount,
        name: "FeedAnts",
        order_id: res.data.id,
        handler: successHandler,
        prefill: {
          email: user.email,
          name: user.firstName + user.lastName,
          contact: "0000000000",
        },
        theme: { color: "#53a20e" },
        modal: {
          ondismiss: async () => {
            localStorage.removeItem("orderId");
            toast.error("Payment Cancelled!");
            await axios.post(`${path}/payment/paymentFailAlert`, {
              userId: user._id,
              orderId: res.data.id,
              error: "checkout form closed",
            });
          },
        },
      };

      // crashlytics().log("Order options: ", orderOptions);
      // crashlytics().log("Sending request to /payment/createOrder");

      // Razorpay is globally avaliable
      const rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", async function (error) {
        // crashlytics().log(`Payment Failed during register: ${error}`);
        // crashlytics().recordError(new Error(error));
        toast.error(
          "Payment failed, please contact feedants support if amount was deducted."
        );
        await axios.post(`${path}/payment/paymentFailAlert`, {
          userId: user._id,
          orderId: res.data.id,
          error: error,
        });
      });
      rzp1.open();
    } catch (error) {
      console.error("Error registerWithPayment: " + error);
      toast.error("Payment failed, please try again!");
    } finally {
      setLoading(false);
    }
  };

  const register = async (user) => {
    setLoading(true);
    try {
      const config = {
        host: `${path}`,
        headers: {
          "Access-Control-Allow-Origin": `${path}`,
          Authorization: `Bearer ${token}`,
        },
      };

      if (
        !user?._id ||
        !contestDetails ||
        contestDetails?.participatedUser?.some((par) => par?._id === user?._id)
      ) {
        return;
      }

      const res = await axios.post(
        `${path}/contest/joinnow`,
        {
          user: user,
          contestId: contestDetails?._id,
        },
        config
      );

      if (res.status === 201) {
        setuserRegistered(true);
        setContestDetails(prev => ({ ...prev, participatedUser: [...prev.participatedUser, user] }))

        toast.success("Registered successfully!")
        const contestTitle =
          contestDetails.responses.sections[2].fields[0].response;
        const fee = contestDetails.responses.sections[2].fields[1].response;
        if (ENV === "prod") {
          ReactGA.event("contest_registed", {
            user_id: user._id,
            contest_id: id,
            contest_name: contestTitle,
          });
          fbq("trackCustom", "contest_registed", {
            user_id: user._id,
            contest_id: id,
            contest_name: contestTitle,
            email: user?.email || "",
            currency: "INR",
            value: parseInt(fee),
          });
        }
      } else {
        toast.error("Error registering in contest!");
      }
    } catch (error) {
      console.info(error);
    } finally {
      setLoading(false);
    }
  };

  const navigateToSubmission = () => {
    const submissionType = contestDetails?.responses?.sections[2]?.fields[7]?.response
    if(submissionType === "Upload") {
      openSubmissionModal()
    }
  }

  function capitalizeFirstWord(word) {
    if (!word || typeof word !== "string") {
      return "";
    }

    return word
      .split('_')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  return (
    <div className=" h-svh w-full fixed inset-0 overflow-y-scroll bg-[#f6f5fa] font-gilroy-regular">
      {/* Header */}
      <Header />

      {signUpModalOpen && (
        <SignUpModal
          setSignUpModalOpen={setSignUpModalOpen}
          register={register}
          registerWithPayment={registerWithPayment}
          registerSlotWithPayment={registerSlotWithPayment}
          paymentType={contestDetails?.responses?.sections[2]?.fields[6]?.response}
          type="register"
        />
      )}
      {user && user._id && (
        <PaymentSuccessModal 
          isOpen={isPaymentSuccessModal}
          onClose={closePaymentSuccessModal}
          referCode={referCode}
        />
      )}
      {IsuserRegistered && SubmissionStart < currentDate && (
        <AddPhoneModal
          isOpen={isAddPhoneModal}
          onClose={closeAddPhoneModal}
          onDone={() => {
            if (addPhonePurpose === "SUBMISSION") {
              navigateToSubmission();
            }
            setAddPhonePurpose(null);
          }}
        />
      )}
      {IsuserRegistered && SubmissionStart < currentDate && (
        <SubmissionUploadModal
          isOpen={isSubmissionModal}
          onClose={closeSubmissionModal}
          maxVideoLength={parseFloat(
            contestDetails.responses?.sections[8]?.fields[2]?.response || 3
          )}
          contestId={contestDetails._id}
          submission={submission}
          setSubmission={setSubmission}
          contestFee={parseInt(
            contestDetails?.responses?.sections[2]?.fields[1]?.response || 0
          )}
          paymentType={contestDetails?.responses?.sections[2]?.fields[6]?.response}
          participationLimit={parseInt(contestDetails?.responses?.sections[8]?.fields[6]?.response ?? 40)}
          registeredLength={contestDetails.participatedUser?.length}
          submissionInfo={submissionInfo}
          slotFeePercentage={parseInt(contestDetails?.responses?.sections[8]?.fields[5]?.response || 0)}
          processingPayment={processingPayment}
          paymentHandler={paymentHandler}
          slotFinalPaymentHandler={slotFinalPaymentHandler}
          uploadConfig={uploadConfig}
          activeDiscount={activeDiscount}
        />
      )}
      {isExploding && (
        <ConfettiExplosion
          force={0.8}
          duration={3000}
          particleCount={200}
          width={window?.innerWidth || 1600}
        />
      )}

      <Modal
        open={showRefundPolicy}
        onCancel={() => setShowRefundPolicy(false)}
        footer={null}
        centered
        title={<span className="text-[#008080] font-gilroy-semibold">Refund Policy</span>}
      >
        <ul className="text-sm text-gray-700 space-y-2 mt-2 font-gilroy-regular">
          <li>• 100% Refund if Contest Is Canceled</li>
          <li>• Full Refund for Technical Failures</li>
          <li>• Transparent Status Updates</li>
        </ul>
      </Modal>


      {/* Bottom Section */}
      <div className=" w-[95%] mx-auto">
        {/* Language Toggle  */}
        <div className=" container mx-auto flex items-center justify-between mt-2 px-2 md:max-w-lg xl:max-w-none">
          <h1 className=" text-xl font-bold tracking-tight">Competitions</h1>
          <div
            className="relative w-20 h-8 ps-2 pe-1.5 flex items-center justify-between rounded-full bg-[#D9D9D9] cursor-pointer"
            onClick={() => setIsEnglish((prev) => !prev)}>
            <div
              className={`absolute w-10 h-8 rounded-full bg-[#008080] shadow-md transition-all duration-500 ${isEnglish ? "left-0" : "right-0"
                }`}
            />

            <p
              className={`z-10 font-semibold text-xs transition-colors ${!isEnglish ? "text-black" : "text-white"}`}>
              ENG
            </p>
            <p
              className={`z-10 font-semibold text-xs transition-colors ${isEnglish ? "text-black" : "text-white"} pt-[2px]`}>
              हिन्दी
            </p>
          </div>
        </div>

        {contestLoading ?
          <div className=" flex w-full items-center justify-center h-[80vh] ">
            <div className=" size-6 border-2 border-[#008080] border-t-white animate-spin rounded-full" />
          </div>
          :
          <>
            {/* ContestContainer */}
            <div className=" flex gap-4 justify-around mx-auto w-full px-2 py-2 max-w-screen-2xl">
              {/* Rules & Rewards Comp for larger screen */}
              <div className="  bg-white rounded-lg overflow-hidden h-fit hidden xl:flex p-4 flex-col gap-2 w-full  md:max-w-lg ">
                {/* Rules & Regulations */}

                {contestDetails?.responses?.sections[5]?.fields?.map((field) => {
                  if (
                    (!isEnglish && field.title === "Rules_And_Regulations_Hindi") ||
                    (isEnglish && field.title === "Rules & Regulations")
                  ) {
                    return <RulesRegulation key={field?.title} rules={field} />;
                  }
                  return null;
                })}

                {/* Rewards */}
                <Rewards
                  data={contestDetails?.responses?.sections[6]?.fields[0]?.response}
                />
              </div>

              <div className="  md:mx-auto w-full md:max-w-lg h-fit space-y-4">
                {/* ContestImage */}
                <div className=" w-full bg-[#008080] rounded-xl overflow-hidden">
                  <img
                    src={
                      contestDetails?.responses.sections[1]?.fields[0]?.response ||
                      ContestImage
                    }
                    alt="contestPoster"
                    className=" w-full h-28 md:h-32 object-cover"
                  />

                  <div className=" p-3 md:p-4 flex flex-col gap-2 rounded-b-xl bg-white">
                    {/* ContestTitle */}
                    <div className=" flex flex-col gap-0.5 pt-0 p-2 border-b-1 border-b-gray-200">
                      <div className="flex items-center justify-between gap-1">
                        <h2 className=" text-xl text-[#0D1C2E] font-semibold font-gilroy-semibold">
                          {
                            contestDetails?.responses.sections[2]?.fields[0]
                              ?.response
                          }
                        </h2>
                        <p className=" text-[#008080]  font-gilroy-bold font-bold">
                          INR{" "}
                          {
                            contestDetails?.responses.sections[2]?.fields[1]
                              ?.response
                          }
                          /-
                        </p>
                      </div>
                      <div className="flex items-center justify-between gap-1">
                        <div className=" text-[#707C97] font-gilroy-medium font-medium flex items-center gap-0.5 text-xs sm:text-sm w-[60%]">
                          <span className="whitespace-nowrap overflow-hidden text-ellipsis block max-w-[40%] sm:max-w-[150px]" title={capitalizeFirstWord(
                            contestDetails?.responses.sections[0].description
                          )}>
                            {capitalizeFirstWord(
                              contestDetails?.responses.sections[0].description
                            )}
                          </span>
                          <p className="bg-[#D9D9D9] rounded-full w-1 h-1 inline-block text-center ml-2 mr-1"></p>{" "}
                          <span>
                            {capitalizeFirstWord(
                              contestDetails?.responses.sections[2]?.fields[2]
                                ?.response
                            )}
                          </span>
                          <p className="bg-[#D9D9D9] rounded-full w-1 h-1 inline-block text-center ml-2 mr-1"></p>{" "}
                          <span>
                            {capitalizeFirstWord(
                              contestDetails?.responses.sections[2]?.fields[3]
                                ?.response
                            )}
                          </span>
                        </div>
                        <div className="flex justify-end gap-0.5 w-[40%] ">
                          <img
                            src={RazorpayIcon}
                            className="size-3 sm:size-4"
                            alt="razorpayIcon"
                          />
                          <p className="text-xs text-gray-400 font-gilroy-light whitespace-nowrap overflow-hidden text-ellipsis block max-w-[70%] sm:max-w-[150px]">Secured with</p>
                        </div>
                      </div>
                    </div>

                    {/* Dates */}
                    <ContestDates
                      fields={contestDetails?.responses?.sections[3]?.fields}
                    />
                  </div>
                  <p className="py-2 w-full text-center text-sm text-white font-gilroy-regular">
                    {function(){
                      const paymentType = contestDetails?.responses?.sections[2]?.fields[6]?.response
                      const limit = contestDetails?.responses?.sections[8]?.fields[6]?.response ?? 40;

                      if (paymentType === "Slotpaid") {
                        const left =
                          limit - (contestDetails.participatedUser?.length ?? 0);

                        return left > 0
                          ? `Only ${left} of ${limit} slots left!`
                          : "All slots filled.";
                      }

                      const left =
                        limit - (submissionInfo?.paidCount ?? 0);

                      return left > 0
                        ? `Only ${left} left hurry up!`
                        : "No spots left.";
                    }()}
                  </p>
                </div>

                <div className="flex w-full items-center gap-2 justify-center text-[#707C97] font-medium">
                  <img src={Trusted} alt="Trusted" className="size-5" />
                  <p className=" text-medium ">Trusted by 2000+ creators.</p>
                </div>

                {/* ContestDetails */}
                <div className=" p-3 md:p-4 flex flex-col gap-2 bg-white rounded-lg overflow-hidden w-full">
                  {/* Description */}
                  <div className="flex flex-col gap-4">
                    <h1 className="text-xl font-gilroy-semibold">
                      Description
                    </h1>
                    <div className="text-[#707C97] leading-tight space-y-4 font-gilroy-regular">
                      {contestDetails?.responses?.sections[4]?.fields?.map(
                        (field) => {
                          if (
                            (!isEnglish && field?.title === "Description_Hindi") ||
                            (isEnglish && field?.title === "Description")
                          ) {
                            return field?.response
                              ?.split("\n")
                              .map((line) => (
                                <p key={line?.substring(0, 10)}>{line}</p>
                              ));
                          }
                          return null;
                        }
                      )}
                    </div>
                  </div>

                  <div className=" xl:hidden">
                    {contestDetails?.responses?.sections[5]?.fields?.map(
                      (field) => {
                        if (
                          (!isEnglish &&
                            field?.title === "Rules_And_Regulations_Hindi") ||
                          (isEnglish && field?.title === "Rules & Regulations")
                        ) {
                          return (
                            <RulesRegulation key={field?.title} rules={field} />
                          );
                        } else if (field?.title === "Judging Parameters") {
                          return (
                            <JudgingParameters
                              key={field.title}
                              parameters={field}
                            />
                          );
                        }
                        return null;
                      }
                    )}
                  </div>
                </div>

                <div className=" xl:hidden">
                  {/* Rewards */}
                  <div className=" p-3 mt-2 md:p-4 flex flex-col gap-2 bg-white rounded-lg overflow-hidden w-full">
                    <Rewards
                      data={
                        contestDetails?.responses?.sections[6]?.fields[0]?.response
                      }
                    />
                  </div>
                  <div className=" p-3 mt-4 md:p-4 flex flex-col gap-2 bg-white rounded-lg overflow-hidden w-full">
                    {/* Judges */}
                    <Judges
                      data={
                        contestDetails?.responses?.sections[7]?.fields[0]?.response
                      }
                    />
                  </div>
                </div>
                {user && user._id && 
                <div className=" p-3 mt-4 md:p-4 flex flex-col gap-2 bg-white rounded-lg overflow-hidden w-full">
                  <ReferCard
                    referCode={referCode}
                  />
                </div>}

                <div
                  className=" py-1.5 border border-teal-600 rounded-lg flex items-center gap-1 justify-center"
                  onClick={() =>
                    history.push("/get-help#how-will-you-receive-prize-money")
                  }>
                  <PlayCircleIcon className="text-[#008080]" />
                  <p className=" tracking-tight underline text-sm font-gilroy-medium">
                    How will you receive prize money?
                  </p>
                </div>

                {!submission?.mediaUrl && (
                  <div className="flex items-center justify-center w-full mt-2">
                    <CountDown
                      regBefore={RegistrationEnd}
                      submissionClose={SubmissionEnd}
                      hasRegistered={IsuserRegistered}
                    />
                  </div>
                )}

                <div className="text-sm flex items-center w-full gap-1 font-gilroy-medium justify-center mb-2">
                  <p className="text-[#707C97]">Read about</p>
                  <span
                    className="text-[#008080] underline cursor-pointer"
                    onClick={() => setShowRefundPolicy(true)}
                  >refund policy</span>
                </div>
                <div className="md:px-4 flex flex-col gap-2 rounded-lg overflow-hidden w-full">
                  {/* Action Button  */}
                  {renderActionButton()}
                </div>
                <div className="pb-4 align-self-start w-full">
                  <div className=" flex flex-col gap-1 w-full ">
                    {/* {!(SubmissionEnd < currentDate) &&
                    submissionList?.length > 0 && (
                      <p className=" text-[#008080] font-semibold tracking-tight">
                        {submissionList?.length} contribution
                        {submissionList?.length === 1 ? "" : "s"}
                      </p>
                    )} */}
                    {!(SubmissionEnd < currentDate) &&
                      contestDetails?.responses?.sections[2]?.fields[4]
                        ?.response === "Paid" &&
                      (!submission || !submission.paid) && (
                        <div className="px-3 py-1 rounded-lg border border-amber-600 bg-amber-100 text-xs text-amber-600">
                          <p>
                            Disclaimer: Only contributions from paid participants
                            will be considered for judging.
                          </p>
                        </div>
                      )}
                  </div>
                </div>
                {/* </div> */}
              </div>

              {/* Judge & JudgeParams Comp for larger screen */}
              <div className="  bg-white rounded-lg overflow-hidden h-fit hidden w-full  xl:flex p-4 flex-col gap-2 md:max-w-lg ">
                {contestDetails?.responses?.sections[5]?.fields?.map((field) => {
                  if (field?.title === "Judging Parameters") {
                    return (
                      <JudgingParameters key={field.title} parameters={field} />
                    );
                  }
                  return null;
                })}

                {/* Judges */}
                <Judges
                  data={contestDetails?.responses?.sections[7]?.fields[0]?.response}
                />
              </div>

              {/* Judge & JudgeParams Comp for larger screen */}
              <div className="  bg-white rounded-lg overflow-hidden h-fit hidden w-full  xl:flex p-4 flex-col gap-2 md:max-w-lg ">
                {contestDetails?.responses?.sections[5]?.fields?.map((field) => {
                  if (field?.title === "Judging Parameters") {
                    return (
                      <JudgingParameters key={field.title} parameters={field} />
                    );
                  }
                  return null;
                })}

                {/* Judges */}
                <Judges
                  data={contestDetails?.responses?.sections[7]?.fields[0]?.response}
                />
              </div>
            </div>
          </>
        }

      </div>
      <div className="w-full flex items-center justify-center pb-1 text-[#707C97] text-sm font-gilroy-medium">
        <span>Powered by</span>
        <img src={RazorpayText} alt="razorpay" className="h-4 w-auto mx-2" />
        <span>• SSL Secured</span>
      </div>
    </div>
  );
}

export default ContestDetails;
